import * as React from "react";
import { SVGProps } from "react";
const SVGComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={26}
    height={23}
    viewBox="0 0 26 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.0104 1.49979L25.124 20.7498C25.2264 20.9271 25.2803 21.1283 25.2803 21.3331C25.2803 21.5379 25.2264 21.7391 25.124 21.9164C25.0216 22.0938 24.8744 22.2411 24.697 22.3435C24.5197 22.4459 24.3185 22.4998 24.1137 22.4998H1.88636C1.68157 22.4998 1.48039 22.4459 1.30304 22.3435C1.12569 22.2411 0.978416 22.0938 0.876023 21.9164C0.77363 21.7391 0.719725 21.5379 0.719727 21.3331C0.719728 21.1283 0.773635 20.9271 0.87603 20.7498L11.9897 1.49979C12.0921 1.32244 12.2394 1.17518 12.4167 1.07279C12.5941 0.970406 12.7952 0.916504 13 0.916504C13.2048 0.916504 13.406 0.970406 13.5833 1.07279C13.7607 1.17518 13.908 1.32244 14.0104 1.49979ZM11.8334 16.6665V18.9998H14.1667V16.6665H11.8334ZM11.8334 8.49979V14.3331H14.1667V8.49979H11.8334Z"
      fill="#FF9900"
    />
  </svg>
);
export default SVGComponent;
